import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../../authentication.service';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  profileImageUrl: any;
  codeValueTechObj: any = {};
  accountImageUrl: any;
  accInfo: any = {}
  codeValueShowObj: any = {};
  allLableShowObj: any = {}
  allLabel: any = []
  httpUrl: any = this.auth.httpUrl;
  constructor(private auth: AuthenticationService, private http: HttpClient) {

  }
  dataSource: any = [];
  async applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }


  allLanguage: any = []
  language_cd: any
  async getAllLanguage() {
    var obj: any = new Object();
    var resp = await this.getAllLanguages(JSON.stringify(obj));
    console.log(resp);
    if (resp['error'] == false) {
      this.allLanguage = resp.data;
      this.language_cd = resp.data[0]['language_cd']
    } else {

    }
  }

  async getAllLabel(obj: any) {
    // var obj: any = new Object();
    //obj['module_cd'] = 'MD'
    var resp = await this.getcomponentLabelvalueswithLanguage(JSON.stringify(obj));
    console.log(resp)
    if (resp['error'] == false) {
      this.allLabel = resp.data;

      obj = {}
      for (let i = 0; i < resp.data.length; i++) {
        obj[resp.data[i]['language_cd'] + resp.data[i]['component_cd'] + resp.data[i]['label_no']] = resp.data[i]['value_to_show'];
      }
      this.allLableShowObj = { ...this.allLableShowObj, ...obj };
      this.auth.allLableShowObjProp = { ...this.allLableShowObj, ...obj };
      console.log(this.allLableShowObj)
    } else {

    }
  }

  async getcomponentLabelvalueswithLanguage(obj: any) {
    const res = await this.http.get<any>(this.httpUrl + '/systemdata/languages/getcomponentLabelvalueswithLanguage' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }
  async getAllLanguages(obj: any) {
    const res = await this.http.get<any>(this.httpUrl + '/systemdata/languages/getAllLanguages' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }
  
  async getFilesLog(obj: any) {
    const res = await this.http.get<any>(this.httpUrl + '/sdp/common/getFilesLog' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }


  capitalizeWords(inputValue: string) {
  return inputValue
    .split(' ')
    .map(w => w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : '')
    .join(' ');
  }


}
